import { useState, useEffect } from 'react';

import { useApi } from '@app/hooks';

import { UserFormInstance } from '../types';

export const useAvailableUsers = () => {
  const api = useApi();
  const [availableUsers, setAvailableUsers] = useState<EntityBase[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    (async () => {
      setLoadingUsers(true);
      const response = await api.users.getUsers({
        sort: '+id',
        offset: 0,
        limit: 100000,
        filter: {
          // @ts-ignore
          active: [true],
        },
      });

      if(response.code === 200) {
        const { data } = response.data;
        const users = data.map(({ id, last_name, first_name, username, position }) => ({
          id,
          name: `${last_name} ${first_name} ${position?.name ? `(${position.name})` : ''} [${username}]`,
        }));
        setAvailableUsers(users);
      }
      setLoadingUsers(false);
    })();
  }, []);

  return { availableUsers, loadingUsers };
};